import { render, staticRenderFns } from "./resource-progress.vue?vue&type=template&id=0975579c&"
import script from "./resource-progress.vue?vue&type=script&lang=js&"
export * from "./resource-progress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports